import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { getNikkiTurnoverDbPageConfigs } from './nikki-turnover-db-page-configs';

const dashboardId = 'global_hr_turnover';
export const NikkiTurnoverDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'Global HR Turnover',
    [Languages.JA]: 'Global HR Turnover',
  },
  enabled: true,
  pages: getNikkiTurnoverDbPageConfigs(dashboardId),
};
